import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'
import { calculateTotalCreditPoints, totalCASPAGPA, totalGPA, calculateCoursesCreditsTotal  } from '@/store/modules/mygrades'
export default {
  methods: {
    isAllowedOnlineCourse (course) {
      const { course_id } = course
      if (!this.savedSchool.online_courses_lab_accepted && !this.hasInPersonLab(course)) return false
      const allowedCourses = this.savedSchool.online_credits_accepted_specific_courses || []
      return allowedCourses.find(({ id })=> id == course_id)
    },
    isAllowedCLEPCourse (course) {
      const { course_id } = course
      if (!this.allowsCLEP) return false
      const allowedCourses = this.savedSchool.clep_accepted_specific_courses || []
      return allowedCourses.find(({ id })=> id == course_id)
    },
    isAllowedPassFailCourse (course) {
      const { course_id } = course
      if (!this.allowsPassFailCourses) return false
      const allowedCourses = this.savedSchool.pass_fail_grade_accepted_courses || []
      return allowedCourses.find(({ id })=> id == course_id)
    },
    hasInPersonLab(course) {
      // "labOnline"
      // "labInPerson"
      const { online_lab, online_course } = course
      return online_course =="true" && online_lab == "labInPerson"
    },
    isPreRequCourse (course) {
      return [].concat(this.userPrereqCourses, this.allOptionalCourses).find(({ id })=> id == course.id)
    },
    filterScienceCourse (course) {
      return course.course_gpa_calculation.toLowerCase() === 'science'
    },
    generateCoursesFilter (courses) {
      return (course) => {
        return courses.find(({ id }) => id === course.course_id)
      }
    },
    requiredCourseCategoryDialog(category) {
      this.showCoursesCategory = true
      this.loadedCategory = category
    },
    hasTakenCourses (courses) {
      return courses.reduce((notTaken, course) => {
        if (!notTaken) return false
        if (this.isWaivedCourse(course)) return true
        return this.allCourses.find(({ course_id }) => course_id === course.id)
      }, true)
    },
    checkOptionalCourseGroup (courseGroup) {
      const reqMin = parseInt(courseGroup.mininum_courses_completed)
      const minCount = isNaN(reqMin) ? 0 : reqMin
      const clearedCourses = this.getClearedOptionalCoursesPasses(courseGroup)
      return clearedCourses.length >= reqMin
    },
    courseCheck (course, school_course) {
      const { id, lab = [], course_lab, quarter, semester, credits } = school_course

      if (this.isWaivedCourse(school_course)) return true
      const needsLab = lab.length &&  (Array.isArray(lab) && lab.length) ? String(lab[0]).toLowerCase() === 'with lab' : false
      const hasSemester = !!semester
      const hasQuarter = !empty(quarter)
      const hasCredits = !!credits
      const courseMatched = course.course_id == id
      if (!courseMatched) return false
      if (!needsLab && !hasCredits) return true
      if (!hasCredits && needsLab) {
        return courseMatched && String(course_lab) == 'true'
      }
      const courseCredits = course.isQuarter && !empty(quarter) ? parseInt(totalCourseCredits(course, isQuarter)) : parseFloat(totalCourseCredits(course))
      const scorePass = (course.isQuarter && hasQuarter) ? parseInt(quarter) : (hasSemester ? (courseCredits >= parseInt(semester)) : (courseCredits >= parseInt(credits)))

      if (needsLab) {
        return courseMatched && course.course_lab == 'true' && scorePass
      }
      return courseMatched && scorePass
    },
    compareGradePass (gradeCheck, prereqCoursesOnly = true) {
      if (gradeCheck) {
        // isGradePassed
        const currentCourses = prereqCoursesOnly ? this.userPrereqCourses : this.allCourses
        if (!currentCourses.length) return false
        for (let index = 0; index < currentCourses.length; index++) {
          const { course_grade } = currentCourses[index]
          if (!isGradePassed(course_grade, gradeCheck)) return false
        }
        return true
      }
      return false
    },
    coursesBelowGrade (gradeCheck = "F", equalPass = true, prereqCoursesOnly = true) {
      const coursesBelowGrade = []
      const currentCourses = prereqCoursesOnly ? this.userPrereqCourses : this.allCourses
      if (!currentCourses.length) return Infinity
      for (let index = 0; index < currentCourses.length; index++) {
        const { course_grade } = currentCourses[index]
        if (!equalPass && course_grade == gradeCheck) {
          coursesBelowGrade.push(currentCourses[index])
          continue
        }
        if (!isGradePassed(course_grade, gradeCheck)) {
          coursesBelowGrade.push(currentCourses[index])
        }
      }
      return coursesBelowGrade.length
    },
    userCreditsFromPast (years = 0, allCourses = false) {
      if (!years) return 0
      const yearsOffset = parseInt(years)
      const userCourses = allCourses ? this.allCourses : this.userPrereqCourses
      const semesters = this.completedSemesters
      const currentTotal = userCourses.reduce((totalCredits,{ semesterId, course_credits }) => {
        const semester = semesters.find(({ id }) => id === semesterId)
        if (!semester) return totalCredits
        const semesterOffset = daysFromYearsAgo(semester.semester_year, years)
        if (semesterOffset < 0) return totalCredits

        return totalCredits + parseFloat(course_credits)
      }, 0)

      return currentTotal
    },
    coursesWithGPACategory (category = null, allCourses = false, pending = false) {
      const userCourses = !pending ? (allCourses ? this.allCourses : this.userPrereqCourses) : (allCourses ? this.allPendingCourses : this.pendingPreReqCourses)
      if (!category) return userCourses
      return userCourses.filter(({ course_gpa_calculation }) => {
        if (!course_gpa_calculation) return false
        return course_gpa_calculation.toLowerCase() == category.toLowerCase()
      })
      return this.filterCoursesWithGPACategory(userCourses, category)
    },
    filterCoursesWithGPACategory (courses = [], category = '') {
      return courses.filter(({ course_gpa_calculation }) => {
        if (!course_gpa_calculation) return false
        return course_gpa_calculation.toLowerCase() == category.toLowerCase()
      })
    },
    coursesWithSubjectCategory (category = null, allCourses = false) {
      const userCourses = allCourses ? this.allCourses : this.userPrereqCourses
      if (!category) return userCourses
      return userCourses.filter(({ course_subject_category }) => {
        if (!course_subject_category) return false
        return course_subject_category.toLowerCase() == category.toLowerCase()
      })
    },
    semestersCompletetionTimeCheck (withCourses = [], completedIn = 0) {
      if (!withCourses.length || completedIn === 0) return false
      const semesters = this.completedSemesters
      return withCourses.reduce((completedInTime, { semesterId, ...others }) => {
        if (!completedInTime) return false
        const semester = semesters.find(({ id }) => id === semesterId)
        const semesterOffset = daysFromYearsAgo(semester.semester_year, completedIn)
        return semesterOffset >= 0
      }, true)
    },
    coursesFromCourses (courses, fromCourses = null) {
      const searchInCourses = fromCourses ? fromCourses : this.allCourses
      return searchInCourses.filter(({ course_id }) => {
        return courses.find(({ id }) => id == course_id)
      })
    },
    onlyPendingCourses (coursesSearch) {
      const allPending = this.pendingPreReqCourses
      if (allPending.length > coursesSearch.length) return false // Number of pending > max
      const matchingCourses = allPending.filter(({ course_id }) => coursesSearch.find(({id}) => id == course_id))
      return matchingCourses.length === coursesSearch.length
    },
    userCategoryCredits (category = null) {
      const allCourses = this.allPreRequisitesCombied
      const credits = this.allPreRequisitesCombied.reduce((sum, course) => {
        const { course_gpa_calculation, course_credits = 0 } = course
        const credits = parseInt(course_credits)
        if (isNaN(credits) || !course_gpa_calculation) return sum

        if (category == null) {
          return sum + credits
        }

        if (category && category.toLowerCase() == course_gpa_calculation.toLowerCase()) {
          return sum + credits
        }

        return sum
      }, 0)
      return credits
    },
    hasCompletedCourse (course) {
      // TOdo: overtide logic
      if (this.hasOverideForCourse(course, 'course')) return true
      const { id, lab, quarter = '', semester, credits, online_course } = course
      if (online_course == "true") {
        if (!this.allowsOnlineCourses) {
          return false
        } else {
          if (!this.isAllowedOnlineCourse(course)) return false
        }
      }
      if (this.isWaivedCourse(course)) return true
      const needsLab = (Array.isArray(lab) && lab.length) ? String(lab[0]).toLowerCase() === 'with lab' : false
      const hasSemester = !!semester
      const hasCredits = !!credits
      return this.allCourses.find((course) => {
        const { course_id, course_lab, course_credits, quarter_credits = '', isQuarter = false } = course
        const courseMatched = course_id == id
        if (!courseMatched) return false
        if (!needsLab && !hasCredits) return true
        if (!hasCredits && needsLab) {
          return courseMatched && course_lab == 'true'
        }
        const courseCredits = isQuarter && !empty(quarter) ? parseInt(totalCourseCredits(course, isQuarter)) : parseFloat(totalCourseCredits(course))
        const compareCredits = empty(quarter) ? parseInt(credits) : parseInt(quarter)
        const scorePass = hasSemester ? (courseCredits >= parseInt(semester)) : (courseCredits >= compareCredits)
        if (needsLab) {
          return courseMatched && course_lab == 'true' && scorePass
        }
        return courseMatched && scorePass
      })
    },
    isWaivedCourse (testCourse) {
      if (this.hasOverideForCourse(testCourse, 'course')) return true
      let waived = false
      const {
        courses_waived_with_bachelors = [],
        ap_science_credits_accepted = false,
        clep_accepted_specific_courses = [],
        pass_fail_grade_accepted_courses = [],
        ap_credits_accepted_specific_courses = []
      } = this.savedSchool

      function checkCourse (waivedBCourses, userCourses = false) {
        return waivedBCourses.find(({ id, course_id }) => userCourses ? course_id === testCourse.id : id === testCourse.id)
      }

      if (courses_waived_with_bachelors && courses_waived_with_bachelors.length && this.hasCompletedBachelorDegree) {
        const waivedBCourses = courses_waived_with_bachelors || []
        waived = checkCourse(waivedBCourses)
        if (waived) return waived
      }

      if (this.allowsAP) {
        if (!ap_science_credits_accepted && testCourse.course_gpa_calculation && testCourse.course_gpa_calculation.toLowerCase() === 'science') return false
        const coursesToCheck = this.allAllowedAPCourses
        waived = checkCourse(coursesToCheck, true)
        if (waived) return waived
      }

      if (this.allowsCLEP) {
        const coursesToCheck = this.allAllowedCLEPCourses
        waived = checkCourse(coursesToCheck, true)
        if (waived) return waived
      }

      if (this.allowsPassFailCourses) {
        const coursesToCheck = this.allAllowedPassFailCouses
        waived = checkCourse(coursesToCheck, true)
        if (waived) return waived
      }
      // Add more checks
      return waived
    },
    checkRequiredCourseCategory (courseCategory, remainingCourses = null) {
      if (this.hasOverideForCourse(courseCategory, 'category')) return true
      const { category: { courses }, ...courseCat } = courseCategory
      const passedCourses = this.getPassedRequiredCourseCatCourses(courseCategory, remainingCourses)
      if (passedCourses.length == 0) return false
      const {
        courses_required_with_lab,
        number_of_courses_completed,
        total_credits_completed
      } = courseCat

      const coursesToComplete = parseInt(number_of_courses_completed)
      const labCount = isNaN(parseInt(courses_required_with_lab)) ? 0 : parseInt(courses_required_with_lab)
      const totalCreditsReq = isNaN(parseInt(total_credits_completed)) ? 0 : parseInt(total_credits_completed)
      // If passed courses count is less than min then exit
      if (!isNaN(coursesToComplete) && passedCourses.length < coursesToComplete) return false
      // check AP
      // check CLEP
      // passedCourses.forEach((c)=> console.log(c.course_name))
      const coursesWithLab = passedCourses.reduce((count, { course_lab, course_id, course_name }) => {
        if (this.isAPorCLEP(course_id)) return count + 1
        if (course_lab == 'true') return count + 1
        return count
      }, 0)

      const totalCredits = passedCourses.reduce((credits, { course_credits, course_id }) => {
        if (this.isAPorCLEP(course_id)) return  parseInt(3) + credits
        if (!isNaN(parseInt(course_credits))) return  parseInt(course_credits) + credits
        return credits
      }, 0)

      return (
        totalCredits >= totalCreditsReq &&
        coursesWithLab >= labCount
      )
    },
    getPassedRequiredCourseCatCourses (courseCategory, remainingCourses = null) {
      const { category: { courses }, ...courseCat } = courseCategory
      const coursesForCourseCat = remainingCourses ? remainingCourses : this.remainingCoursesAfterPrereqs
      const {
        included_courses = [],
        excluded_courses = []
      } = courseCat
      const coursesToCheck = [...Object.values(courses), ...included_courses].filter((id) => !excluded_courses.find((c) => c.id == id))
      return coursesForCourseCat.filter(({ course_id }) => coursesToCheck.find(({ id }) =>  id === course_id))
    },
    getClearedOptionalCoursesPasses ({ options = [], mininum_courses_completed }, coursesToCheckIn = null) {
      const allCourses = coursesToCheckIn ? coursesToCheckIn : this.allCourses
      const reqMin = parseInt(mininum_courses_completed)
      const hasByPass = this.hasOverideForCourse({ options, mininum_courses_completed }, 'optionalcourse')
      let currentCleared = 0
      const clearedCourses = []

      function incrementClearedCourses (course) {
        currentCleared += 1
        clearedCourses.push(course)
        return true
      }

      options.forEach((course) => {
        if (currentCleared >= reqMin) return false
        if (this.isWaivedCourse(course)) return incrementClearedCourses(course)
        if (hasByPass) return incrementClearedCourses(course)
        const hasTakenCourse = allCourses.find(({ course_id }) => course_id === course.id)
        if (!hasTakenCourse || currentCleared >= reqMin) return false
        if (course.lab && course.lab.length) {
          course.course_lab = "true"
        }
        const isPassed = this.courseCheck(hasTakenCourse, course)
        if (isPassed) return incrementClearedCourses(hasTakenCourse)
      })
      return clearedCourses
    },
    isAPorCLEP (id) {
      const isAP = this.allAPCourses.find(({ course_id }) => id === course_id)
      // this.allAPCourses.forEach((c) => console.log(c.course_subject_category))
      // this.allCLEPCourses.forEach((c) => console.log(c.course_subject_category))
      if (isAP) return true


      const isCLEP = this.allCLEPCourses.find(({ course_id }) => id === course_id)
      // console.log(isCLEP, 'isCLEP')
      if (isCLEP) return true
      return false
    },
  },
  computed: {
    // isPreRequCourse (course) {
    //     return [].concat(this.userPrereqCourses, this.allOptionalCourses).find(({ id })=> id == course.id)
    //   },
    allowedUserColleges () {
      return this.userColleges.filter(({ college_type, degree }) =>  {
        if (college_type == '2 Year' && !this.allowsCommunityCollege) return false
        return true
      })
    },
    completedSemesters () {
      if (this.allowedUserColleges && this.allowedUserColleges.length) {
        let SEMESTERS = []
        this.allowedUserColleges.forEach(({ semesters }) => {
          if (semesters && semesters.length) {
            semesters.forEach(sem => {

              if (
                sem.semester_completion_status &&
                trim(sem.semester_completion_status).toLowerCase() === 'completed'
              ) {
                SEMESTERS = [...SEMESTERS, ...semesters]
              }
            })
          }
        })
        return SEMESTERS
      }
      return []
    },
    allAllowedCoursesFrom4YearCollege () {
      const allowedCourses = this.savedSchool.specific_courses_completed_4_year_college || []
      return this.allCoursesFrom4YearCollege.filter(({ course_id }) => allowedCourses.find(({ id }) => course_id === id))
    },
    allCoursesFrom4YearCollege () {
      const userColleges = this.userColleges.filter(({ college_type }) =>  college_type == '4 Year')
      return getCoursesFromColleges(userColleges)
    },


    remainingPrerequsites () {
      const allClearedPrereqs = this.allPreRequisitesCombied
      const remaining = []
      this.savedSchool.required_courses
    },
    totalPendingCredits () {
      const pendingCourses = this.pendingPreReqCourses
      return pendingCourses.reduce((sum, { course_credits }) => {
        return sum + parseInt(course_credits)
      }, 0)
    },
    pendingPreReqCourses () {
      const requiredCourses = this.savedSchool.required_courses
      const completedCourses = this.allCourses
      const allPending = this.allPendingCourses
      const mainPrereqs = allPending.filter(({ course_id }) => this.savedSchool.required_courses.find(({ id }) => id === course_id))
      const optionalCategoryCourses = this.savedSchool.optional_courses_group.map(({ options }) => {
        return allPending.filter(({ course_id }) => options.find(({ id }) => id == course_id))
      }).flat()
      // .filter((course) => !completedCourses.find(({ course_id }) => course.course_id == course_id))
      const nonRequiredPreReqs = allPending.filter(({ course_id }) => !requiredCourses.find(({ id }) => course_id == id))
      const requiredCatPendingCourses = nonRequiredPreReqs.filter(({ course_id }) => !optionalCategoryCourses.find((c) => course_id == c.course_id))
      const requiredCatCourses = this.savedSchool.required_category_courses.map((cc) => this.getPassedRequiredCourseCatCourses(cc, requiredCatPendingCourses)).flat()

      return [
        ...mainPrereqs,
        ...optionalCategoryCourses,
        ...requiredCatCourses
      ]
    },

    allPendingCourses () {
      return getCoursesFromColleges(this.allowedUserColleges, 'in-progress')
    },
    allowsAP () {
      return this.savedSchool.ap_credits_accepted_transcript
    },
    allowsPassFailCourses () {
      return this.savedSchool.pass_fail_grade_accepted
    },
    allowsCLEP () {
      return this.savedSchool.clep_accepted
    },
    allowsCommunityCollege () {
      return !!this.savedSchool.community_college_courses_accepted_regionally_accredited
    },

    hasTakenCommunityCollege () {
      return this.userColleges.find(({ college_type, degree }) =>  college_type == '2 Year' && degree == 'Completed')
    },
    allAllowedPassFailCouses () {
      const allowedCourses = this.savedSchool.pass_fail_grade_accepted_courses || []
      if (allowedCourses.length === 0 || allowedCourses[0] == 0) return this.allPassFailCourses
      return this.allPassFailCourses.filter(({ course_id, pass_fail_grade }) => pass_fail_grade == "true" && allowedCourses.find(({ id }) => course_id === id))
    },
    allAllowedOnlineCourses () {
      const allowedCourses = this.savedSchool.online_credits_accepted_specific_courses || []
      return this.allAPCourses.filter(({ course_id }) => allowedCourses.find(({ id }) => course_id === id))
    },
    allPassFailCourses () {
      return this.allCourses.filter(({ pass_fail_course }) => pass_fail_course)
    },
    allOnlineCourses () {
      return this.allCourses.filter(({ online_course }) => online_course == "true")
    },
    allOnlineWithLab () {
      return this.allOnlineCourses.filter(({ course_lab }) => course_lab == "true")
    },

    allCLEPCourses () {
      // check for completed degeree ?
      return this.allowedUserColleges.map(({ clepcourses }) => clepcourses).flat()
    },

    isFirstTimeApplicant () {
      return true
    },
    hasCompletedBachelorDegree () {
      return this.allowedUserColleges.find(({ degree, college_degree_awarded }) => {
        return degree == 'Completed' && ['Bachelor', 'Masters', 'Doctorate'].indexOf(college_degree_awarded) >= 0
      })
    },


    coursesMinGradePass () {
      if (!this.allCourses.length) return false
      if (this.savedSchool.minimumGrade_C_required_specific_courses && this.savedSchool.minimumGrade_C_required_specific_courses.length) {
        const allCourses = this.allCourses
        for (let index = 0; index < this.savedSchool.minimumGrade_C_required_specific_courses.length; index++) {
          const { id } = this.savedSchool.minimumGrade_C_required_specific_courses[index]
          const course = allCourses.find((course) => id === course.course_id)
          if (!course) return false
          if (!isGradePassed(course.course_grade, 'C')) return false
        }
        return true
      }
      return false
    },
    usersPassedCourses () {
      return this.allCourses.filter((course) => {
        const schoolCourse = this.savedSchool.required_courses.find(({ id }) => id == course.course_id)
        if (!schoolCourse) return false
        return this.courseCheck(course, schoolCourse)
      })
    },
    preReqGradePassed () {
      const userPrereqCourses = this.userPrereqCourses
      if (!userPrereqCourses.length) return false
      return this.compareGradePass(this.savedSchool.minimum_grade_course)
    },
    preReqsCoursesExist () {
      return this.userPrereqCourses.length >= this.savedSchool.required_courses.length
    },
    allPreRequisitesCombied () {
      const prereqs = this.userPrereqCourses
      const optionalCourses = this.allOptionalCourses
      const remaining = this.remainingCoursesAfterPrereqs
      // const requiredCourses = this.savedSchool.required_category_courses.map(this.checkRequiredCourseCategory)
      return [
        ...prereqs,
        ...optionalCourses,
        ...remaining
      ]
    },
    userPrereqCourses () {
      return this.usersPassedCourses.filter(({ course_id }) => {
        return this.savedSchool.required_courses.find(({ id }) => id === course_id)
      })
    },
    hasCompletedAllPrerequisites () {
      return (
        (this.usersRemaingingPrerequisites.length === 0) &&
        (this.requiredOptionalCoursesCount === this.allOptionalCourses.length) &&
        ((filterZeroArrays(this.savedSchool.required_category_courses).length - this.usersRemaingingCourseCat.length) === 0)
      )
    },
    requiredOptionalCoursesCount () {
      return filterZeroArrays(this.savedSchool.optional_courses_group).reduce((count, group) => {
        return count + parseInt(group.mininum_courses_completed)
      }, 0)
    },
    allOptionalCourses () {
      const result = this.savedSchool.optional_courses_group.map(group => this.getClearedOptionalCoursesPasses(group)).flat()
      return result
    },
    passedCourses () {
      const passedReqs = []
      this.savedSchool.required_courses.forEach((course) => {
        if (this.hasCompletedCourse(course)) {
          passedReqs.push(course)
        }
      })
      return passedReqs
    },
    usersRemaingingPrerequisites () {
      const passedCourses = this.passedCourses
      const a = this.usersRemaingingCourseCat
      return this.savedSchool.required_courses.filter(({ id }) => !passedCourses.find((course) => course.id == id))
    },
    allowsOnlineCourses () {
      return !!this.savedSchool.online_courses_accepted_regionally_accredited
    },
    allCourses () {
      return getCoursesFromColleges(this.allowedUserColleges)
    },
    usersRemaingingCourseCat () {
      if (this.savedSchool.required_category_courses[0] === 0) return []
      const passedCourses = this.savedSchool.required_category_courses.filter((courseCat) => this.checkRequiredCourseCategory(courseCat))
      return passedCourses
    },
    remainingCoursesAfterPrereqs () {
      const requiredCourses = this.savedSchool.required_courses
      const remainingCourses = [...this.allCourses, ...this.allAllowedCLEPCourses, ...this.allAllowedAPCourses].filter(({ course_id }) => {
        return !requiredCourses.find(({ id }) => course_id == id)
      })

      const optionalCategoryCourses = this.allOptionalCourses

      return remainingCourses.filter(({ course_id }) => {
        return !optionalCategoryCourses.find(({ id }) => course_id == id)
      })
    },
    allAllowedCLEPCourses () {
      // check for completed degeree ?
      const allowedCourses = this.savedSchool.clep_accepted_specific_courses || []
      if (allowedCourses.length === 0 || allowedCourses[0] == 0) return this.allCLEPCourses
      return this.allCLEPCourses.filter(({ course_id, course_grade }) => course_grade === 'Pass' && allowedCourses.find(({ id }) => course_id === id))
    },
    allAllowedAPCourses () {
      const allowedCourses = this.savedSchool.ap_credits_accepted_specific_courses || []
      if (allowedCourses.length === 0 || allowedCourses[0] == 0) return this.allAPCourses
      return this.allAPCourses.filter(({ course_id }) => allowedCourses.find(({ id }) => course_id === id))
    },
    allCLEPCourses () {
      // check for completed degeree ?
      return this.allowedUserColleges.map(({ clepcourses }) => clepcourses).flat()
    },
    allAPCourses () {
      // check for completed degeree ?
      return this.allowedUserColleges.map(({ apcourses }) => apcourses).flat()
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkprerequisitesmixin.js